import View from 'cdna/core/view';

export default View.extend({
    el: '<li><a></a></li>',
    bindings: {
        'Id': 'attr data-nav',
        'Title a': 'text',
        'isActive': 'classToggle active'
    },
    events: {
        'click': function() {
            this.model.set('isActive', true);
        }
    }
});


/** WEBPACK FOOTER **
 ** ./client/navItemView.js
 **/